/**
 * Copyright (c) 2024 rports (r), All rights reserved.
 *
 *     ______    _______  _______  ______    _______  _______ 
 *    |    _ |  |       ||       ||    _ |  |       ||       |
 *    |   | ||  |    _  ||   _   ||   | ||  |_     _||  _____|
 *    |   |_||_ |   |_| ||  | |  ||   |_||_   |   |  | |_____ 
 *    |    __  ||    ___||  |_|  ||    __  |  |   |  |_____  |
 *    |   |  | ||   |    |       ||   |  | |  |   |   _____| |
 *    |___|  |_||___|    |_______||___|  |_|  |___|  |_______|
 *
 * filename      : NavBarItem.jsx
 * description   : {{insert here}}
 * creation date : 25/02/2024
 * author        : "Luis CRUZ" <luis.cruz@rports.net>
 */



// --------------------------------------------------------------------------------
//      IMPORTS
// --------------------------------------------------------------------------------

import {
    Fragment,
} from 'react';

import {
    View,
    Flex,
} from '@aws-amplify/ui-react';

import {
    useComponentContext,
} from '@/components/core';



// --------------------------------------------------------------------------------
//      FUNCTIONS
// --------------------------------------------------------------------------------

function NavBarItem({ classPrefix, isSelectable = false, isActive = false, underlineProps = undefined, children, ...rest }) {
    // Component context
    const { ctx } = useComponentContext();

    return (
        <Fragment>
            <Flex
                direction='column'
                position='relative'
                justifyContent='center'
                alignItems='center'
                alignContent='center'
                textAlign='center'
                gap={ctx.theme.tokens.space.zero}
                {...rest}
                className={(isSelectable === true) && `${classPrefix}-item`}
            >
                {children}

                {(isSelectable === true) &&
                    <Fragment>
                        <View
                            position='absolute'
                            height={ctx.theme.tokens.space.xxxs}
                            width={ctx.theme.tokens.space.relative.full}
                            bottom={ctx.theme.tokens.space.zero.value}
                            className={
                                [
                                    `${classPrefix}-item-underline`,
                                    ((isActive === true) ? `${classPrefix}-item-underline-active` : `${classPrefix}-item-underline-inactive`)
                                ].join(' ')
                            }
                            {...underlineProps}
                        />
                    </Fragment>
                }
            </Flex>
        </Fragment>
    );
}



// --------------------------------------------------------------------------------
//      EXPORTED OBJECTS
// --------------------------------------------------------------------------------

export {
    NavBarItem,
};



// End of file
